import { AdminsListContainer } from '@/modules/Admins';

const AdminsList = (): JSX.Element => <AdminsListContainer />;

export default AdminsList;
